<script>
import { elements } from '../inspectable.js';


import { State, adjustOrderForFixedItems } from '../store.js';
import Button from './Button.svelte';
import TextArea from './TextArea.svelte';
import Icon from './Icon.svelte';
import InspectorPane from './Inspector/InspectorPane.svelte';
import { v4 as uuid4 } from 'uuid'

export let state = {}
let args = {}
var textValue = ""
var index = null 
var changeKey = ""

State.subscribe(n => { 
    state = n 
    let newIds = ""
    state.components.forEach((element, i) => {
        if (element !== undefined) {
            if (element.id == state.activeElementId) {
                args = element.args
                index = i
                
            }
            newIds += element.id
        }
        
    });
    const newKey = newIds + "-" + index

    if (newKey != changeKey) {
        changeKey = newKey
    }

    textValue = JSON.stringify(args, null, 2)
})

const save = () => {

    State.update(s => {
        s.components.forEach((element) => {
            if (element.id == state.activeElementId) {
                element.args = JSON.parse(textValue)
            }
        });
        return s
    })

}

$: activeElementId = $State.activeElementId
$: settings = state.components[index]
$: pageSettings = state.page

$: {
    if (settings) {
        $State.components[index] = settings
    }

    if (pageSettings) {
        $State.page = pageSettings
    }

    if (index !== null && $State.components[index].type !== undefined) {
        if ($State.components[index].type == "fixedFooter") {
            $State.activeElementId = ""
        }
    }
}

function capfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const deleteSelectedElement = () => {

    let components = $State.components.splice(index, 1)

    index = Math.max(0, Math.min($State.components.length - 1, index - 1))
    if ($State.components.length > 0) {
        $State.activeElementId = $State.components[index].id
    } else {
        $State.activeElementId = ""
        $State.components = []
    }

    $State.components = adjustOrderForFixedItems($State.components)
}

const duplicateSelectedElement = () => {

    if ($State.components[index].type == "navBar") {
        return
    }

    let e = JSON.parse(JSON.stringify($State.components[index]))
    e.id = uuid4()
    e.args.name = `${e.type}-${uuid4().substring(0,4)}`

    $State.components.splice(index + 1, 0, e)

    index = Math.max(0, Math.min($State.components.length - 1, index + 1))
    if ($State.components.length > 0) {
        $State.activeElementId = $State.components[index].id
    } else {
        $State.activeElementId = ""
        $State.components = []
    }

    $State.components = adjustOrderForFixedItems($State.components)
}

$: debug = false

</script>

{ #key changeKey }
    {#if $State.activeElementId == "" && $State.previewMode}
        {#each Object.entries(pageSettings.args.meta.order).sort((first, second) => {return first[1] < second[1] ? -1 : 1}).map(el => el[0])  as key}
            {#if (key != "name")}
                <InspectorPane hidden={true} limited={true} bind:settings={pageSettings.args[key]}></InspectorPane>
            {/if}
        {/each}
    {/if}
{ /key }

{#if settings}

    <div class="container" class:preview={!state.previewMode || state.activeElementId == ""} >
        <div style="width: 100%;">
            <div style="padding: 0px 16px; display: flex; flex: 0 0 100%; margin-bottom: 10px; justify-content: space-between;">
                
                <div style="border-bottom: 1px dashed rgba(255,255,255,0.2); display: flex; align-items: center; flex-direction: row; justify-content: flex-start;">
                    <Icon name="rectangle.and.pencil.and.ellipsis" ></Icon><h4 style="margin-left: 5px;"><input bind:value={settings.args.name}/></h4>
                </div>
                
                <div style=" display: flex; align-items: center; flex-direction: row; justify-content: flex-end;">

                    <Button clear=true action="{duplicateSelectedElement}">
                        <Icon name="plus.rectangle.on.rectangle"></Icon>
                    </Button>
                    <div style="width: 15px;"></div>
                    <Button clear=true action="{deleteSelectedElement}">
                        <Icon color="#F46865" name="trash"></Icon>
                    </Button>
                </div>

            </div>
        </div>

        { #key changeKey }
            {#each Object.entries(args.meta.order).sort((first, second) => {return first[1] < second[1] ? -1 : 1}).map(el => el[0])  as key}
                {#if (key != "name")}
                    <InspectorPane bind:settings={settings.args[key]}></InspectorPane>
                {/if}
            {/each}
        {/key}
        
        <div style="margin-bottom:10px; flex-end; display: flex; justify-content: flex-end;">
            <Button action="{() => {debug = !debug}}">
                { debug ? "✕" : "Debug" }
            </Button>
        </div>

        {#if debug}
            <div style="margin-top: -15px;">
                <TextArea bind:value={textValue} minRows={5} maxRows={100}/>
                <div style="display: flex; justify-content: stretch;">
                    <Button icon="checkmark" iconHeight="16px" stretch={true} juicy={true} action={save}>Save</Button>
                </div>
            </div>
        {/if}
    </div>

{/if}

<style>


.container {
    /* width: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding-left: 100px; */
}

.preview {
    display: none;
}

input, select {
    background-color: var(--secondary-button-bg-color);
    border: 1px solid rgba(0,0,0,0);
    box-shadow: none;
    outline: none;
    color: var(--text-color);
    margin: 0px;
    padding: 3px 6px;
    border-radius: 10px;
    text-align: right;
    font-size: 0.9rem;
}

input:focus, textarea:focus, select:focus, select:focus {

}

h4 input {
    background-color: rgba(0,0,0,0);
    text-align: left;
    font-weight: 400;
    font-size: 1.1rem;
    align-self: stretch;
}

hr {
    margin: 0px;
}

</style>